import { localize } from '../../nls.js';
var AccessibilityHelpNLS;
( ((function(AccessibilityHelpNLS) {
    AccessibilityHelpNLS.accessibilityHelpTitle = ( localize(1259, "Accessibility Help"));
    AccessibilityHelpNLS.openingDocs = ( localize(1260, "Opening the Accessibility documentation page."));
    AccessibilityHelpNLS.readonlyDiffEditor = ( localize(1261, "You are in a read-only pane of a diff editor."));
    AccessibilityHelpNLS.editableDiffEditor = ( localize(1262, "You are in a pane of a diff editor."));
    AccessibilityHelpNLS.readonlyEditor = ( localize(1263, "You are in a read-only code editor."));
    AccessibilityHelpNLS.editableEditor = ( localize(1264, "You are in a code editor."));
    AccessibilityHelpNLS.changeConfigToOnMac = ( localize(
        1265,
        "Configure the application to be optimized for usage with a Screen Reader (Command+E)."
    ));
    AccessibilityHelpNLS.changeConfigToOnWinLinux = ( localize(
        1266,
        "Configure the application to be optimized for usage with a Screen Reader (Control+E)."
    ));
    AccessibilityHelpNLS.auto_on = ( localize(
        1267,
        "The application is configured to be optimized for usage with a Screen Reader."
    ));
    AccessibilityHelpNLS.auto_off = ( localize(
        1268,
        "The application is configured to never be optimized for usage with a Screen Reader."
    ));
    AccessibilityHelpNLS.screenReaderModeEnabled = ( localize(1269, "Screen Reader Optimized Mode enabled."));
    AccessibilityHelpNLS.screenReaderModeDisabled = ( localize(1270, "Screen Reader Optimized Mode disabled."));
    AccessibilityHelpNLS.tabFocusModeOnMsg = ( localize(
        1271,
        "Pressing Tab in the current editor will move focus to the next focusable element. Toggle this behavior{0}.",
        '<keybinding:editor.action.toggleTabFocusMode>'
    ));
    AccessibilityHelpNLS.tabFocusModeOffMsg = ( localize(
        1272,
        "Pressing Tab in the current editor will insert the tab character. Toggle this behavior{0}",
        '<keybinding:editor.action.toggleTabFocusMode>'
    ));
    AccessibilityHelpNLS.stickScroll = ( localize(
        1273,
        "Focus Sticky Scroll{0} to focus the currently nested scopes.",
        '<keybinding:editor.action.focusStickyDebugConsole>'
    ));
    AccessibilityHelpNLS.showAccessibilityHelpAction = ( localize(1274, "Show Accessibility Help"));
    AccessibilityHelpNLS.listSignalSounds = ( localize(
        1275,
        "Run the command: List Signal Sounds for an overview of all sounds and their current status."
    ));
    AccessibilityHelpNLS.listAlerts = ( localize(
        1276,
        "Run the command: List Signal Announcements for an overview of announcements and their current status."
    ));
    AccessibilityHelpNLS.quickChat = ( localize(
        1277,
        "Toggle quick chat{0} to open or close a chat session.",
        '<keybinding:workbench.action.quickchat.toggle>'
    ));
    AccessibilityHelpNLS.startInlineChat = ( localize(
        1278,
        "Start inline chat{0} to create an in editor chat session.",
        '<keybinding:inlineChat.start>'
    ));
    AccessibilityHelpNLS.setBreakpoint = ( localize(
        1279,
        "The Debug: Inline Breakpoint command{0} will set or unset a breakpoint at the current cursor position in the active editor.",
        '<keybinding:editor.debug.action.toggleInlineBreakpoint>'
    ));
    AccessibilityHelpNLS.debugExecuteSelection = ( localize(
        1280,
        "The Debug: Execute Selection command{0} will execute the selected text in the debug console.",
        '<keybinding:editor.debug.action.selectionToRepl>'
    ));
})(AccessibilityHelpNLS || (AccessibilityHelpNLS = {}))));
var InspectTokensNLS;
( ((function(InspectTokensNLS) {
    InspectTokensNLS.inspectTokensAction = ( localize(1281, "Developer: Inspect Tokens"));
})(InspectTokensNLS || (InspectTokensNLS = {}))));
var StandaloneCodeEditorNLS;
( ((function(StandaloneCodeEditorNLS) {
    StandaloneCodeEditorNLS.editorViewAccessibleLabel = ( localize(1288, "Editor content"));
    StandaloneCodeEditorNLS.accessibilityHelpMessage = ( localize(1289, "Press Alt+F1 for Accessibility Options."));
})(StandaloneCodeEditorNLS || (StandaloneCodeEditorNLS = {}))));
var ToggleHighContrastNLS;
( ((function(ToggleHighContrastNLS) {
    ToggleHighContrastNLS.toggleHighContrast = ( localize(1290, "Toggle High Contrast Theme"));
})(ToggleHighContrastNLS || (ToggleHighContrastNLS = {}))));
var StandaloneServicesNLS;
( ((function(StandaloneServicesNLS) {
    StandaloneServicesNLS.bulkEditServiceSummary = ( localize(1291, "Made {0} edits in {1} files"));
})(StandaloneServicesNLS || (StandaloneServicesNLS = {}))));
export { AccessibilityHelpNLS, InspectTokensNLS, StandaloneCodeEditorNLS, StandaloneServicesNLS, ToggleHighContrastNLS };
